<template>
  <div class="animated fadeIn">
    <b-card id="hoverInfo" v-if="showHoverBooking" class="hoverInfo">
      <bookingdetails v-bind:booking="hoverBooking" :readonly="true"></bookingdetails>
    </b-card>
    <b-card>
      <b-card-body>
        <b-button-toolbar aria-label="Toolbar with button groups and input groups">
          <b-input-group class="md-7">
            <b-checkbox @change="toggleFilter()"></b-checkbox>
            <b-button variant="outline" size="sm">Filter:</b-button>
            <b-dropdown v-bind:text="selTerminal.terminalName" variant="outline-secondary" title="Välj terminal"
              size="sm" v-bind:disabled="!enableFilter" ref="termSelectorDropdown" v-on:show="TermSelectorShown">
              <b-dropdown-form>
                <b-form-input size="sm" ref="termSearchInput" v-model="filterTermList" placeholder="Sök..."
                  @keypress="TermSearchKeyPress"></b-form-input>
              </b-dropdown-form>
              <b-dropdown-item v-for="n in GetFilteredTermList(filterTermList)" :key="n.terminalId"
                v-on:click="selTerminal = n; updateFilter()">{{n.terminalName}}
              </b-dropdown-item>
            </b-dropdown>
            <datepicker v-model="dateFilter" @change="updateFilter()" @input="updateFilter()" :stepper="true"
              v-bind:disabled="!enableFilter">
            </datepicker>
          </b-input-group>
          <b-input-group>
            <b-button size="sm" @click="fastFindVisible = true" :variant="IsFastFindFilterActive() ? 'danger' : ''">
              <b-icon-search></b-icon-search> Snabbsök
            </b-button>
          </b-input-group>
          <b-input-group class="md-7" v-if="this.selectedrows.length > 0">
            Urval: {{ GetSelectedIds().length }}
            <bookingactionbutton :ids="GetSelectedIds()"></bookingactionbutton>
          </b-input-group>
          <b-input-group>
            &nbsp;
            <b-button size="sm" @click="NewBooking()">+ Ny bokning</b-button>
          </b-input-group>
        </b-button-toolbar>
      </b-card-body>
    </b-card>
    <div class="card">
      <div class="card-header">Frakter</div>
      <div class="card-body">
        <queryviewlistdetail qvtype="Bookings" ref="blist" title="Fraktdetaljer" :selectable="true"
          v-on:rowclicked="onclick" :hovericons="[{ id: 'ShowInfo', icon: 'info-circle' }]" v-on:iconhover="onhover"
          v-on:iconunhover="onunhover" v-bind:currentkey="currId" v-on:currentkeychanged="oncurrentkeychanged"
          v-bind:extrafilter="extrafilter" v-on:selectionchanged="SelectonChanged" :detailsvisible="myModal"
          :isBusy="isBusy">
          <template v-slot:details>
            <bookingdetails v-if="booking && booking.booking" v-bind:booking="booking" v-on:change="onchange"
              :readonly="booking.booking.Locked"></bookingdetails>
          </template>
          <template v-slot:actionbuttons>
            <bookingactionbutton v-if="currId > 0" :ids="[currId]" v-on:actionready="OnActionReady">
            </bookingactionbutton>
          </template>
        </queryviewlistdetail>
      </div>
      <b-modal title="Snabbsök" v-model="fastFindVisible" @ok="PerformFastFind()">
        <fastfindbookings v-model="currFastFind" @change="onfastfindchange"></fastfindbookings>
      </b-modal>
    </div>
  </div>
</template>

<script>
import queryview from "./../queryview/queryview";
import queryviewlistdetail from "./../queryview/queryviewlistdetail";
import bookingdetails from "./../booking/bookingdetails";
import datepicker from "../../components/datepicker";
import lmodal from "../../components/l-modal";
import bookingactionbutton from "./../booking/bookingactionbutton"
import fastfindbookings from "./fastfindbookings.vue"
import moment from "moment";
import Bookingactionbutton from './bookingactionbutton.vue';
import { qvCondition } from "../../lib/qvcondition.js";

const cndLib = new qvCondition();
import { Api } from "../../lib/api";
const api = new Api();

export default {
  name: "bookinglist",
  components: { queryview, queryviewlistdetail, bookingdetails, datepicker, bookingactionbutton, fastfindbookings, lmodal },
  data() {
    return {
      //id: 0,
      myModal: false,
      booking: {},
      hoverBooking: {},
      showHoverBooking: false,
      currId: null,
      terminals: null,
      selTerminal: { terminalId: 0, terminalName: '(ALLA TERMINALER)' },
      extrafilter: null,
      dateFilter: moment(new Date()).format("YYYY-MM-DD"),
      enableFilter: false,
      selectedrows: [],
      fastFindVisible: null,
      currFastFind: null,
      currFilterIds: null,
      filterTermList: null,
      isBusy: false,
    };
  },
  created() {
    this.updateFilter();
    api.get("/api/Booking/GetTerminals").then((res) => {
      this.terminals = [];
      this.terminals.push({ terminalId: 0, terminalName: '(ALLA TERMINALER)' });
      this.selTerminal = this.terminals[0];
      res.data.map(x => {
        this.terminals.push(x);
      });
    });
  },
  methods: {
    async onclick(row) {
      this.setCurrent(row._key);
    },
    setCurrent(id) {
      this.currId = id;
      this.myModal = true;
      //this.booking = {};
      this.isBusy = true;
      api.get("/api/Booking/GetDetails?id=" + this.currId).then((res) => {
        this.booking = res.data;
        this.myModal = true;
        this.isBusy = false;
        //this.$forceUpdate();
      });
    },
    onhover(v) {
      console.log(v);

      var id = v.row._key;
      this.showHoverBooking = true;
      var xPosition = v.ev.fromElement.offsetLeft + v.ev.clientX + 100;
      var yPosition = v.ev.fromElement.offsetTop; // + v.ev.clientY;
      this.hoverBooking = {};
      api.get("/api/Booking/GetDetails?id=" + id).then((res) => {
        this.hoverBooking = res.data;
        var crd = document.getElementById("hoverInfo");
        crd.style.left = xPosition + "px";
        crd.style.top = yPosition + "px";
      });
    },
    onunhover(v) {
      console.log("UnHover" + v);
      this.hoverBooking = {};
      this.showHoverBooking = false;
    },
    step(s) {
      this.$refs.blist.StepCurrent(s);
    },
    oncurrentkeychanged(row) {
      this.onclick(row);
    },
    isCurrentSelected() {
      var r = this.getCurrentRow();
      if (r) return r.selected;
    },
    getCurrentRow() {
      if (this.currId > 0) return this.$refs.blist.GetRowById(this.currId);
      return null;
    },
    toggleFilter() {
      this.enableFilter = !this.enableFilter;
      this.updateFilter();
    },
    updateFilter() {
      let flt = [];

      if (this.enableFilter && this.selTerminal && this.selTerminal.terminalId > 0)

        flt.push({field:'TerminalId',type:'=',eq:this.selTerminal.terminalId});
      if (this.enableFilter && this.dateFilter)
        flt.push({field:'DeliveryDateText',type:'=',eq:moment(String(this.dateFilter)).format("YYYY-MM-DD")})
      if (this.IsFastFindFilterActive())
        flt.push({field:'Id',type:'in',list: this.currFilterIds});

      this.extrafilter = flt.length>0 ? JSON.stringify(flt) : null;
    },
    onchange(id) {
      this.setCurrent(id);
    },
    SelectonChanged(sel) {
      this.selectedrows = sel;
    },
    GetSelectedIds() {
      return !this.selectedrows ? [] :
        this.selectedrows.map(x => x._key);
    },
    OnActionReady() {
      //Will refresh
      this.setCurrent(this.currId);
    },
    NewBooking() {
      api.post('/api/booking/createnew').then(res => {
        if (res.data > 0) {
          this.setCurrent(res.data);
          return;
        }
        alert('Det gick inte att skapa ny bokning.');
      })
    },
    onfastfindchange(ff) {
      this.currFastFind = ff;
    },
    PerformFastFind() {
      api.post('/api/booking/FastFindSearchFor', this.currFastFind).then((res) => {
        console.log(res.data);
        this.currFilterIds = (res.data.bookingids && res.data.bookingids.length > 0) ? res.data.bookingids : null;
        this.updateFilter();
      });
    },
    IsFastFindFilterActive() {
      return this.currFilterIds && this.currFilterIds.length > 0;
    },
    TermSearchKeyPress(ev) {
      if (ev.key == 'Enter') {
        var qs = this.GetFilteredTermList(this.filterTermList);
        if (qs.length > 0) {
          //this.QvSelect(qs[0].id);
          this.selTerminal = qs[0];
          this.updateFilter();
          this.filterTermList = null;
          this.$refs.termSelectorDropdown.hide(true);
          ev.preventDefault();
        }
      }
      console.log(ev);
    },
    GetFilteredTermList(filter) {
      if (!this.terminals)
        return [];

      var res = [];
      this.terminals.map(x => res.push(x));
      if (filter) {
        var flt = filter.toUpperCase();
        res = res.filter(x => x.terminalName.toUpperCase().indexOf(flt) >= 0);
      }
      //return res;
      return res.sort((a, b) => { return a.terminalName.toString().localeCompare(b.terminalName.toString())});
    },
    TermSelectorShown(ev) {
      setTimeout(() => {
        this.$refs.termSearchInput.focus();
      }, 500);
    },
  },
};
</script>
